import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
// eslint-disable-next-line import/no-named-default
import { default as OriginalButton } from 'src/components/Button';

const SettingsWrapper = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 40px;
`;

const SettingsButton = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 40px;
  cursor: pointer;
  text-align: center;
  line-height: 40px;

  &:hover {
    background-color: rgba(var(--black), 0.2);
  }
`;

const SettingsButtonIcon = styled(Svg)`
  width: 14px;

  * {
    fill: var(--white) !important;
  }
`;

const SettingsPopup = styled('div')`
  position: absolute;
  right: 0;
  top: 36px;
  min-width: 250px;
  overflow: hidden;
  box-shadow: var(--ph-box-shadow-sm);
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--white);
  padding: 10px;

  label {
    transition: var(--ph-transition);
    font-size: var(--ph-text-sm);
    background-color: var(--transparent);
    color: var(--black);
    padding: 0 0 0 36px;
    margin: 0;
    line-height: 35px;
    position: relative;
  }

  span {
    height: 16px;
    width: 16px;
    border-radius: var(--ph-border-radius-xs);
    border: 2px solid var(--ph-light-blue-500);
    top: 50%;
    left: 10px;
    transform: translateY(-50%);

    &::before {
      top: 0 !important;
      left: 1px !important;
      background:
        svg-load('../../Svg/icons/checkbox.svg', fill=#29a9e0) 0 center
        no-repeat !important;
    }
  }
`;

const SettingSearch = styled('div')`
  position: relative;

  label {
    margin: 0;
    padding: 0;
    border: 0;
    border-bottom: solid 1px var(--white);
  }

  input {
    background-color: transparent;
    color: var(--black);
    padding-right: 45px;
  }

  input,
  input::placeholder {
    font-size: var(--ph-text-sm);
  }
`;

const SettingSearchIcon = styled(Svg)`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;

  path {
    fill: var(--ph-gray-500);
  }
`;

const SettingsFooter = styled('div')`
  border-top: solid 1px var(--ph-gray-50);
  padding: 14px 0 0;
`;

const Button = styled(OriginalButton)`
  min-width: 0;
  padding: 5px 15px;
  border-radius: var(--ph-border-radius-sm);
  font-size: var(--ph-text-sm);

  & + & {
    margin-left: 10px;
  }

  &[class*='__link'] {
    border-bottom: 0;
    font-size: var(--ph-text-sm);
  }

  & button {
    margin: 10px 0 10px 14px;
  }
`;

const SettingsContent = styled('div')`
  max-height: 200px;
  overflow-y: auto;
`;

const AdminWrapper = styled('div')`
  margin-top: 16px;
`;

export default {
  SettingsWrapper,
  SettingsButton,
  SettingsButtonIcon,
  SettingsPopup,
  SettingSearch,
  SettingSearchIcon,
  SettingsFooter,
  Button,
  SettingsContent,
  AdminWrapper,
};
